import { useAuth0 } from '@auth0/auth0-react';
import { Button } from 'components/ui/button';
import { Card } from 'components/ui/card';
import React from 'react';

function SignUpPage () {
  const { loginWithRedirect } = useAuth0();

  const handleSignUp = () => {
    // screen_hint opens Universal Login directly on the signup screen
    loginWithRedirect({
      authorizationParams: { screen_hint: 'signup' },
      appState: { returnTo: '/chat' },
    });
  };

  return (
    <div className="min-h-screen bg-muted/40 p-8">
      <div className="mx-auto w-full max-w-4xl">
        <Card className="mt-8 flex flex-col items-center p-8 text-center">
          <h3 className="mb-4 text-3xl font-semibold text-foreground">
            Create a free account
          </h3>

          <h5 className="mb-8 max-w-[600px] text-base text-muted-foreground">
            Sign up free and start exploring
          </h5>

          <Button
            size="lg"
            onClick={handleSignUp}
          >
            Sign up
          </Button>
        </Card>
      </div>
    </div>
  );
}

export default SignUpPage;
